import type { QuickstartT } from "@/types/database/profiles";
import type { RoleT } from "@/types/zod/auth";
import { createFileRoute } from "@tanstack/react-router";
import QrCodeInviteForm from "../../../features/qr-code/components/QrCodeInviteForm";
import type { OrganisationSummary } from "../../../types";
import type { UserMetadata } from "../../../types/zod/auth";

const OrganisationQuickstartQrCodePage = () => {
  const search = Route.useSearch();

  return (
    <section className="md-width">
      <QrCodeInviteForm
        defaultRole={search.role}
        defaultOrganisationId={search.organisation?.organisation_id}
      />
    </section>
  );
};

export const Route = createFileRoute("/_app/invite/qr-code")({
  component: OrganisationQuickstartQrCodePage,
  validateSearch: (search: Record<string, unknown>): UserMetadata => {
    return {
      role: (search?.role as RoleT) ?? undefined,
      email: (search?.email as string) ?? undefined,
      organisation: (search?.organisation as OrganisationSummary) ?? undefined,
      quickstart: (search?.quickstart as QuickstartT) ?? undefined,
    };
  },
});
